export const INCIDENT_API_BASE_URL = '/neo4j-incident-api';
export const INCIDENT_IO_INCIDENTS_BASE_URL =
  'https://app.incident.io/neo4j/incidents';
